"use strict";exports.__esModule = true;exports.parse = parse;exports.parseObj = parseObj;exports.str = str;exports.default = void 0;


var _is = require("./is");


/**
                            * @namespace json
                            *
                            */



/**
                                * Парсит входящий аргумент, при ошибке возвращает null
                                *
                                *
                                * @param {?string} s
                                * @example
                                * parse( "{\"x\":3}" ) // { x: 3 }
                                * parse( [] ) // null
                                * @returns {(mixed | null)}
                                * @memberof json
                                */
function parse(s) {

  if (typeof s !== 'string') return null;

  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
}

/**
   * Парсит входящий аргумент, если результат не является простым объектом, возвращает null
   *
   *
   * @param {?string} s
   * @example
   * parseObj( "{\"x\":3}" ) // { x: 3 }
   * parseObj( "[1]" ) // null
   * @returns {(AnyMap | null)}
   * @memberof json
   */
function parseObj(s) {
  var parsed = parse(s);
  return (0, _is.isObj)(parsed) ? parsed : null;
}

/**
   * Сериализует аргумент, возвращает null если была ощибка
   *
   *
   * @param {mixed} any
   * @example
   * str( { x: 3 } ) // "{\"x\":3}"
   * const obj = {}; obj.self = obj; str( obj ) // null
   * @returns {(string | null)}
   * @memberof json
   */
function str(any) {
  var result = null;
  try {
    var r = JSON.stringify(any);
    if (r) {
      result = r;
    }
  } catch (err) {
    console.log(err);
  }
  return result;
}var _default =


{
  parse: parse,
  parseObj: parseObj,
  str: str };exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/json.js
// module id = 79
// module chunks = 0